import { Config } from '@comall-backend-builder/core/lib/parser';

import './product.less';

export let config: Config = {
    entities: {
        // 商品列表
        product: {
            apiPath: '/products',
            properties: {
                salesTags: {
                    type: 'string',
                    displayName: '特殊标签',
                },
                styleCode: {
                    type: 'string',
                    displayName: '华夏款号',
                    controlConfig: {
                        placeholder: '款号',
                    },
                },
                matnr: {
                    type: 'string',
                    displayName: '物料编码',
                },
                pullOffSaleTime: {
                    type: 'string.dateTime',
                    displayName: '定时下架时间',
                },
                putOnSaleTime: {
                    type: 'string.dateTime',
                    displayName: '定时上架时间',
                },
                maxSaleNum: {
                    type: 'number.integer',
                    displayName: '用户最多可兑换量',
                },
                isTopping: {
                    type: 'string.options.select',
                    displayName: '是否置顶',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '是',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '否',
                        },
                    ],
                },
                preStartTime: {
                    type: 'string',
                    displayName: '预售开始时间',
                },
                preEndTime: {
                    type: 'string',
                    displayName: '预售结束时间',
                },
                preHotStartTime: {
                    type: 'string',
                    displayName: '预热开始时间',
                },
                preHotEndTime: {
                    type: 'string',
                    displayName: '预热结束时间',
                },
                preSendDay: {
                    type: 'string',
                    displayName: '发货时间',
                },
                blackFlag: {
                    type: 'string.options.select',
                    displayName: '是否黑名单',
                    options: [
                        {
                            id: '1',
                            name: '是',
                        },
                        {
                            id: '0',
                            name: '否',
                        },
                    ],
                },
                id: {
                    type: 'number.integer',
                    displayName: 'ID',
                },
                brand: {
                    type: 'string',
                    displayName: '品牌',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                blackRemark: {
                    type: 'string',
                    displayName: '黑名单备注',
                },
                price: {
                    type: 'string',
                    displayName: '价格',
                },
                pointPrice: {
                    type: 'string',
                    displayName: '积分',
                },
                showName: {
                    type: 'string',
                    displayName: '展示名称',
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                },
                pzgPic: {
                    type: 'string.image.text',
                    displayName: '电商图片',
                },
                middlePic: {
                    type: 'string.image.text',
                    displayName: '中台图片',
                },
                supportCustomerMade: {
                    type: 'string.options.select',
                    displayName: '是否支持客定',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                saleStatus: {
                    type: 'string.status.badge',
                    displayName: '是否上架',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOT_SALES',
                            name: '下架',
                        },
                    ],
                },
                stockStatus: {
                    type: 'string.options.select',
                    displayName: '库存状态',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有库存',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无库存',
                        },
                    ],
                },
                ecStock: {
                    type: 'number.integer',
                    displayName: '电商库存',
                },
                totalStock: {
                    type: 'number.integer',
                    displayName: '总库存',
                },
                availableStock: {
                    type: 'number.integer',
                    displayName: '总可卖数',
                },
                ecAvailableStock: {
                    type: 'number.integer',
                    displayName: '电商可卖数',
                },
                type: {
                    type: 'string.options.select',
                    displayName: '类型',
                    options: [
                        {
                            id: 'ALL',
                            name: '全部',
                        },
                        {
                            id: 'SALES',
                            name: '销售商品',
                        },
                        {
                            id: 'GIFT',
                            name: '赠品',
                        },
                        {
                            id: 'FK_GIFT',
                            name: '费控赠品',
                        },
                        {
                            id: 'FK_POINTS',
                            name: '积分商品',
                        },
                    ],
                },
                supportAppointment: {
                    type: 'string.status.badge',
                    displayName: '预约看货状态',
                    options: [
                        {
                            id: '0',
                            name: '支持',
                        },
                        {
                            id: '1',
                            name: '不支持',
                        },
                    ],
                },
                searchType: {
                    type: 'string.status.badge',
                    displayName: '商品搜索',
                    options: [
                        {
                            id: '0',
                            name: '可搜索',
                        },
                        {
                            id: '1',
                            name: '隐藏',
                        },
                    ],
                },
                supportPreSales: {
                    type: 'string.status.badge',
                    displayName: '是否支持预售',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                levelList: {
                    type: 'array.options.checkbox',
                    displayName: '会员等级',
                    width: 300,
                    options: [],
                    source: {
                        apiPath: '/skuPointLevel/levelDict',
                    },
                },
            },
            filters: {
                salesTag: {
                    type: 'array.optionIds.select',
                    displayName: '特殊标签',
                    options: [],
                    source: {
                        apiPath: '/loader/product-goods-salesTag-select',
                    },
                    multiple: true,
                },
                zppxl: {
                    type: 'string',
                    displayName: '品牌系列',
                    controlConfig: {
                        placeholder: '品牌系列',
                    },
                },
                matnr: {
                    type: 'string',
                    displayName: '物料编码',
                    controlConfig: {
                        placeholder: '物料编码',
                    },
                },
                skn: {
                    type: 'string',
                    displayName: 'skn',
                    controlConfig: {
                        placeholder: 'skn',
                    },
                },
                blackRemark: {
                    type: 'string',
                    displayName: '黑名单备注',
                    controlConfig: {
                        placeholder: 'blackRemark',
                    },
                },

                zgyskh: {
                    type: 'string',
                    displayName: '供应商款号',
                    controlConfig: {
                        placeholder: '供应商款号',
                    },
                },
                blackFlag: {
                    type: 'string.options.select',
                    displayName: '是否黑名单',
                    options: [
                        {
                            id: '1',
                            name: '是',
                        },
                        {
                            id: '0',
                            name: '否',
                        },
                    ],
                },
                isTopping: {
                    type: 'string.options.select',
                    displayName: '是否置顶',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '是',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '否',
                        },
                    ],
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                    controlConfig: {
                        placeholder: '商品名称',
                    },
                },
                style_code: {
                    type: 'string',
                    displayName: '华夏款号',
                    controlConfig: {
                        placeholder: '华夏款号',
                    },
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                    controlConfig: {
                        placeholder: 'SKU',
                    },
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                    controlConfig: {
                        placeholder: 'SPU',
                    },
                },
                brand: {
                    type: 'string',
                    displayName: '品牌',
                    controlConfig: {
                        placeholder: '品牌',
                    },
                },
                supportCustomerMade: {
                    type: 'string.options.select',
                    displayName: '客定状态',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                saleStatus: {
                    type: 'string.options.select',
                    displayName: '上架状态',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOTSALES',
                            name: '下架',
                        },
                    ],
                    multiple: true,
                },
                pullOffSaleStatus: {
                    type: 'string.options.select',
                    displayName: '是否定时下架',
                    options: [
                        {
                            id: '1',
                            name: '是',
                        },
                        {
                            id: '0',
                            name: '否',
                        },
                    ],
                },
                putOnSaleStatus: {
                    type: 'string.options.select',
                    displayName: '是否定时上架',
                    options: [
                        {
                            id: '1',
                            name: '是',
                        },
                        {
                            id: '0',
                            name: '否',
                        },
                    ],
                },
                saleNumStatus: {
                    type: 'string.options.select',
                    displayName: '是否限制购买量',
                    options: [
                        {
                            id: '1',
                            name: '是',
                        },
                        {
                            id: '0',
                            name: '否',
                        },
                    ],
                },
                stock_status: {
                    type: 'string.options.select',
                    displayName: '库存状态',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有库存',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无库存',
                        },
                    ],
                },
                availableStockStatus: {
                    type: 'string.options.select',
                    displayName: '可卖数状态',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有可卖数',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无可卖数',
                        },
                    ],
                },
                havePic: {
                    type: 'string.options.select',
                    displayName: '是否有电商图片',
                    options: [
                        {
                            id: 'HAVE',
                            name: '是',
                        },
                        {
                            id: 'NOT_HAVE',
                            name: '否',
                        },
                    ],
                },
                haveDcPic: {
                    type: 'string.options.select',
                    displayName: '是否有平台图片',
                    options: [
                        {
                            id: 'HAVE',
                            name: '是',
                        },
                        {
                            id: 'NOT_HAVE',
                            name: '否',
                        },
                    ],
                },
                type: {
                    type: 'string.options.select',
                    displayName: '类型',
                    options: [
                        {
                            id: 'ALL',
                            name: '全部',
                        },
                        {
                            id: 'SALES',
                            name: '销售商品',
                        },
                        {
                            id: 'GIFT',
                            name: '赠品',
                        },
                        {
                            id: 'FK_GIFT',
                            name: '费控赠品',
                        },
                    ],
                },
                priceRangeId: {
                    type: 'string.options.select',
                    displayName: '价格区间',
                    options: [
                        {
                            id: '0_5k',
                            name: '0-5000',
                        },
                        {
                            id: '5k_10k',
                            name: '5000-10000',
                        },
                        {
                            id: '10k_15k',
                            name: '10000-15000',
                        },
                        {
                            id: '15k_20k',
                            name: '15000-20000',
                        },
                        {
                            id: '20k_25k',
                            name: '20000-25000',
                        },
                        {
                            id: '25k_30k',
                            name: '25000-30000',
                        },
                        {
                            id: '30k',
                            name: '30000以上',
                        },
                    ],
                },
                categoryCode: {
                    type: 'string.options.select',
                    displayName: '货品品类',
                    options: [],
                    source: {
                        apiPath: '/loader/product-category-code-select',
                    },
                },
                // 商品经营管理中的圈口筛选字段
                zqk: {
                    type: 'array.optionIds.select',
                    displayName: '圈口',
                    options: [],
                    source: {
                        apiPath: '/products/getZQK',
                    },
                },
                supportAppointment: {
                    type: 'string.options.select',
                    displayName: '预约看货状态',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                supportPreSales: {
                    type: 'string.options.select',
                    displayName: '是否支持预售',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                levelList: {
                    type: 'array.options.checkbox',
                    displayName: '会员等级',
                    width: 300,
                    options: [],
                    source: {
                        apiPath: '/skuPointLevel/levelDict',
                    },
                },
                styleCode: {
                    type: 'string',
                    displayName: '华夏款号',
                    controlConfig: {
                        placeholder: '华夏款号',
                    },
                },
                zxlh: {
                    type: 'string',
                    displayName: '系列号',
                    controlConfig: {
                        placeholder: '系列号',
                    },
                },
                zcsfj: {
                    type: 'string.options.select',
                    displayName: '成色',
                    options: [],
                    source: {
                        apiPath: '/products/getZCSFJ',
                    },
                },
                ec_stock_status: {
                    type: 'string.options.select',
                    displayName: '是否有电商库存',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有库存',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无库存',
                        },
                    ],
                },
                ec_available_stock_status: {
                    type: 'string.options.select',
                    displayName: '是否有电商可卖数',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有可卖数',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无可卖数',
                        },
                    ],
                },
                searchType: {
                    type: 'string.options.select',
                    displayName: '商品搜索',
                    options: [
                        {
                            id: '1',
                            name: '隐藏',
                        },
                        {
                            id: '0',
                            name: '可搜索',
                        },
                    ],
                },
            },
        },
        // 积分商品列表
        pointProduct: {
            apiPath: '/products/point_products',
            properties: {
                brand: {
                    type: 'string',
                    displayName: '品牌',
                },
                name: {
                    type: 'string',
                    displayName: '名称',
                },
                price: {
                    type: 'number.price',
                    displayName: '价格',
                },
                pointPrice: {
                    type: 'number.pointPrice',
                    displayName: '积分价格',
                },
                showName: {
                    type: 'string',
                    displayName: '展示名称',
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                },
                pzgPic: {
                    type: 'string',
                    displayName: '商品图片',
                },
                supportCustomerMade: {
                    type: 'string.options.select',
                    displayName: '是否支持客定',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                saleStatus: {
                    type: 'string.options.select',
                    displayName: '是否上架',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOT_SALES',
                            name: '下架',
                        },
                    ],
                },
                stock_status: {
                    type: 'string.options.select',
                    displayName: '库存状态',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有库存',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无库存',
                        },
                    ],
                },
                pullOffSaleTime: {
                    type: 'string.dateTime',
                    displayName: '定时下架时间',
                },
                putOnSaleTime: {
                    type: 'string.dateTime',
                    displayName: '定时上架时间',
                },
                maxSaleNum: {
                    type: 'number.integer',
                    displayName: '用户最多可兑换量',
                },
            },
            filters: {
                name: {
                    type: 'string',
                    displayName: '商品名称',
                    controlConfig: {
                        placeholder: '商品名称',
                    },
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                    controlConfig: {
                        placeholder: 'SKU',
                    },
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                    controlConfig: {
                        placeholder: 'SPU',
                    },
                },
                brand: {
                    type: 'string',
                    displayName: '品牌',
                    controlConfig: {
                        placeholder: '品牌',
                    },
                },
                supportCustomerMade: {
                    type: 'string.options.select',
                    displayName: '客定状态',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                saleStatus: {
                    type: 'string.options.select',
                    displayName: '上架状态',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOTSALES',
                            name: '下架',
                        },
                    ],
                },
                stock_status: {
                    type: 'string.options.select',
                    displayName: '库存状态',
                    options: [
                        {
                            id: 'IN_STOCK',
                            name: '有库存',
                        },
                        {
                            id: 'OUT_OF_STOCK',
                            name: '无库存',
                        },
                    ],
                },
            },
        },

        // 商品基本属性
        productBase: {
            apiPath: '/products/:id/base_info',
            properties: {
                blackRemark: {
                    type: 'string',
                    displayName: '黑名单备注',
                },
                brand: {
                    type: 'string',
                    displayName: '品牌',
                },
                name: {
                    type: 'string',
                    displayName: '名称',
                },
                price: {
                    type: 'string',
                    displayName: '价格',
                },
                pointPrice: {
                    type: 'string',
                    displayName: '积分',
                },
                levelNames: {
                    type: 'string',
                    displayName: '会员等级',
                },
                showName: {
                    type: 'string',
                    displayName: '展示名称',
                },
                sku: {
                    type: 'string',
                    displayName: 'SKU',
                },
                spu: {
                    type: 'string',
                    displayName: 'SPU',
                },
                supportCustomerMade: {
                    type: 'string.options.select',
                    displayName: '是否支持客定',
                    options: [
                        {
                            id: 'SUPPORT',
                            name: '支持',
                        },
                        {
                            id: 'NOT_SUPPORT',
                            name: '不支持',
                        },
                    ],
                },
                saleStatus: {
                    type: 'string.options.select',
                    displayName: '是否上架',
                    options: [
                        {
                            id: 'SALES',
                            name: '上架',
                        },
                        {
                            id: 'NOT_SALES',
                            name: '下架',
                        },
                    ],
                },
                chargeType: {
                    type: 'string.options.select',
                    displayName: '计价类型',
                    options: [
                        {
                            id: 'MONEY',
                            name: '按金额计价',
                        },
                        {
                            id: 'WEIGHT',
                            name: '按重量计价',
                        },
                    ],
                },
                goldWeight: {
                    type: 'string',
                    displayName: '黄金净重',
                },
                salesTags: {
                    type: 'string.options.select',
                    displayName: '特殊销售标签',
                    options: [
                        {
                            id: '01',
                            name: '一口价',
                        },
                        {
                            id: '02',
                            name: '特惠价',
                        },
                        {
                            id: '03',
                            name: '推广价',
                        },
                    ],
                },
                type: {
                    type: 'string.options.select',
                    displayName: '商品类型',
                    options: [
                        {
                            id: 'SALES',
                            name: '销售商品',
                        },
                        {
                            id: 'GIFT',
                            name: '赠品',
                        },
                        {
                            id: 'FK_GIFT',
                            name: '费控赠品',
                        },
                    ],
                },
                weight: {
                    type: 'string',
                    displayName: '重量',
                },
            },
        },

        // 商品参数展示
        productAttribute: {
            apiPath: '/products/:id/attributes',
            properties: {
                key: {
                    type: 'string',
                    displayName: '名称',
                },
                value: {
                    type: 'string',
                    displayName: '值',
                },
            },
        },

        // 商城展示属性
        productInsideAttribute: {
            apiPath: '/products/:id/inside_show_attribute',
            properties: {
                detailApp: {
                    type: 'string.richText',
                    displayName: '移动端详情',
                },
                detailPc: {
                    type: 'string.richText',
                    displayName: 'PC端详情',
                },
                imageUrls: {
                    type: 'array.images',
                    displayName: '图片',
                },
                videoUrl: {
                    type: 'string.video.picker',
                    displayName: '视频',
                },
            },
        },

        // 中台展示属性
        productOutsideAttribute: {
            apiPath: '/products/:id/outside_show_attribute',
            properties: {
                detailApp: {
                    type: 'string.richText',
                    displayName: '移动端详情',
                },
                detailPc: {
                    type: 'string.richText',
                    displayName: 'PC端详情',
                },
                imageUrls: {
                    type: 'array.images',
                    displayName: '图片',
                },
                videoUrl: {
                    type: 'string.video.picker',
                    displayName: '视频',
                },
            },
        },

        // 商品库存子资源
        productStock: {
            apiPath: '/products/:id/stock',
            properties: {
                realStoreName: {
                    type: 'string',
                    displayName: '所在库位',
                },
                storeCode: {
                    type: 'string',
                    displayName: '门店编码',
                },
                sknCount: {
                    type: 'string',
                    displayName: 'SKN数量',
                },
            },
        },

        // 商品可卖数子资源
        productSaleNumber: {
            apiPath: '/products/:id/sale_number',
            properties: {
                canSaleNumber: {
                    type: 'string',
                    displayName: '当前可卖数',
                },
                lockStock: {
                    type: 'string',
                    displayName: '待扣减库存',
                },
                totalStock: {
                    type: 'string',
                    displayName: '总库存数',
                },
            },
        },
    },
    components: {
        ProductSelector: {
            component: 'productSelector',
        },
        productInfoListView: {
            component: 'Card',
            entity: 'product',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'productInfoFilter',
                    },
                    // {
                    //     component: 'productInfoBatchBtns',
                    // },
                    {
                        component: 'ProductGoodsInfo',
                    },
                ],
            },
        },

        productInfoFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sku',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'spu',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'brand',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'type',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'skn',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'blackRemark',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'styleCode',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'zgyskh',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        productInfoBatchBtns: {
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量导入图片',
                        type: 'primary',
                        tooltip: '上传压缩文件格式为.zip格式，并且不超过100M',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.zip',
                    action: '/templates/UPDATE_IMAGE',
                    className: 'upload-button',
                },
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量删除图片',
                        type: 'primary',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.xls,.xlsx,.csv',
                    action: '/products/delPzgPic',
                    className: 'upload-button',
                },
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量导入修改展示名称',
                        type: 'primary',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.xls,.xlsx,.csv',
                    action: '/templates/UPDATE_SHOW_NAME',
                    className: 'upload-button',
                },
                {
                    component: 'ExportButton',
                    text: '下载模板',
                    type: 'default',
                    source: {
                        apiPath: '/templates/UPDATE_SHOW_NAME',
                    },
                    flex: '0 0 auto',
                },
            ],
        },

        productInfoDataTable: {
            component: 'DataTable',
            switchRefresh: true,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'sku',
                },
                {
                    property: 'spu',
                },
                {
                    property: 'pzgPic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'middlePic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                },
                {
                    property: 'brand',
                    width: 120,
                },
                {
                    property: 'styleCode',
                },
                {
                    property: 'price',
                },
                {
                    property: 'type',
                    width: 100,
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '编辑',
                        path: '/product/info/{{row.id}}',
                    },
                ],
            },
        },

        productInfoDetailView: {
            component: 'Card',
            content: {
                component: 'Tabs',
                items: [
                    {
                        title: '商品基础资料',
                        content: {
                            component: 'productInfoDetailBaseForm',
                        },
                    },
                    {
                        title: '商品参数展示',
                        content: {
                            component: 'ProductInfoDetailAttributeList',
                        },
                    },
                    {
                        title: '商品展示属性 - 电商',
                        content: {
                            component: 'productInfoDetailInsideAttribute',
                        },
                    },
                    {
                        title: '商品展示属性 - 中台',
                        content: {
                            component: 'productInfoDetailOutsideAttribute',
                        },
                    },
                ],
            },
        },

        productInfoDetailBaseForm: {
            component: 'ModifyForm',
            entity: 'productBase',
            loaderType: 'get',
            direction: 'horizontal',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 8,
            footer: {
                style: {
                    textAlign: 'right',
                },
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                    },
                    {
                        text: '提交',
                        type: 'primary',
                        htmlType: 'submit',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            fields: [
                {
                    property: 'sku',
                    modifiable: false,
                },
                {
                    property: 'spu',
                    modifiable: false,
                },
                {
                    property: 'name',
                    modifiable: false,
                },
                {
                    property: 'brand',
                    modifiable: false,
                },
                {
                    property: 'chargeType',
                    modifiable: false,
                },
                {
                    property: 'goldWeight',
                    modifiable: false,
                    displayConfig: {
                        className: 'suffix-weight',
                    },
                },
                {
                    property: 'salesTags',
                    modifiable: false,
                },
                {
                    property: 'type',
                    modifiable: false,
                },
                {
                    property: 'weight',
                    modifiable: false,
                    displayConfig: {
                        className: 'suffix-weight',
                    },
                },
                {
                    property: 'showName',
                },
            ],
        },

        // productInfoDetailAttributeList: {
        //     component: 'DataTable',
        //     entity: 'productAttribute',
        //     loaderType: 'search',
        //     loadFirstPage: true,
        //     rowKey: 'id',
        //     columns: [
        //         {
        //             property: 'key',
        //         },
        //         {
        //             property: 'value',
        //         },
        //     ],
        // },

        productInfoDetailInsideAttribute: {
            component: 'Card',
            entity: 'productInsideAttribute',
            loaderType: 'get',
            content: {
                component: 'productInfoShowAttributeInsideEditForm',
            },
        },

        productInfoShowAttributeInsideEditForm: {
            component: 'ModifyForm',
            direction: 'vertical',
            footer: {
                style: {
                    textAlign: 'right',
                },
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                    },
                    {
                        text: '提交',
                        type: 'primary',
                        htmlType: 'submit',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            fields: [
                {
                    property: 'detailApp',
                    controlConfig: {
                        uploadConfig: {
                            apiPath: '/images',
                            fileName: 'fileName',
                        },
                    },
                },
                {
                    property: 'detailPc',
                    controlConfig: {
                        uploadConfig: {
                            apiPath: '/images',
                            fileName: 'fileName',
                        },
                    },
                },
                {
                    property: 'imageUrls',
                    controlConfig: {
                        maxCount: 5,
                        fileName: 'fileName',
                        uploadType: 'multi',
                        sortable: true,
                        multiple: true,
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                        maxSize: 10240,
                        uploadLimitSizeErrorMessage:
                            '图片{{file.name}}超出限制，最大上传 {{maxSize}} kb 图片',
                        preview: {
                            visible: true,
                            size: 400,
                        },
                    },
                },
                {
                    property: 'videoUrl',
                    controlConfig: {
                        maxCount: 1,
                        fileName: 'file_name',
                        uploadUrl: `${ENV.API_ROOT}/video`,
                        mode: 'picture-card',
                        maxSize: 10 * 1024,
                    },
                },
            ],
            submitSuccessBehavior: {
                route: 'goBack',
            },
        },

        productInfoDetailOutsideAttribute: {
            component: 'Card',
            entity: 'productOutsideAttribute',
            loaderType: 'get',
            content: {
                component: 'productInfoShowAttributeOutsideForm',
            },
        },

        productInfoShowAttributeOutsideForm: {
            component: 'ModifyForm',
            direction: 'vertical',
            className: 'product-info-show-attribute-outside-form',
            fields: [
                {
                    property: 'detailApp',
                    modifiable: false,
                },
                {
                    property: 'detailPc',
                    modifiable: false,
                },
                {
                    property: 'imageUrls',
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 104,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                        },
                    },
                },
                {
                    property: 'videoUrl',
                    modifiable: false,
                },
            ],
        },

        productGoodsListView: {
            component: 'Card',
            entity: 'product',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'productGoodsFilter',
                    },
                    {
                        component: 'ProductGoodsView',
                    },
                ],
            },
        },

        productGoodsFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sku',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'spu',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                // {
                //     property: 'supportCustomerMade',
                //     controlConfig: {
                //         style: { width: 200 },
                //     },
                // },
                {
                    property: 'saleStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'stock_status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'ec_stock_status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'priceRangeId',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'availableStockStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'ec_available_stock_status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'havePic',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'haveDcPic',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'categoryCode',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'supportAppointment',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'supportPreSales',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'styleCode',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'zxlh',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'zcsfj',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'zqk',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 250 },
                    },
                },
                {
                    property: 'blackFlag',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'isTopping',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'skn',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'blackRemark',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'zppxl',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'salesTag',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
                {
                    property: 'searchType',
                    controlConfig: {
                        allowClear: true,
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        productGoodsView: {
            component: 'FlexLayout',
            direction: 'vertical',
            align: 'justify',
            items: [
                {
                    component: 'Card',
                    title: '商品基本属性',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'productGoodsBaseDetail',
                    },
                },
                {
                    component: 'Card',
                    title: '商品库存',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'productGoodsStockDataTable',
                    },
                },
                {
                    component: 'Card',
                    title: '商品可卖数',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'productGoodsSaleNumberDetail',
                    },
                },
            ],
        },

        productGoodsBaseDetail: {
            component: 'Detail',
            entity: 'productBase',
            loaderType: 'get',
            direction: 'vertical',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 4,
            fields: [
                {
                    property: 'sku',
                    label: 'SKU',
                },
                {
                    property: 'spu',
                    label: 'SPU',
                },
                {
                    property: 'name',
                    label: '名称',
                },
                {
                    property: 'brand',
                    label: '品牌',
                },
                {
                    property: 'showName',
                    label: '展示名称',
                },
                {
                    property: 'price',
                    label: '价格',
                },
            ],
        },

        productGoodsStockDataTable: {
            component: 'DataTable',
            entity: 'productStock',
            loadFirstPage: true,
            columns: [
                {
                    property: 'realStoreName',
                },
                {
                    property: 'storeCode',
                },
                {
                    property: 'sknCount',
                },
            ],
        },

        productGoodsSaleNumberDetail: {
            component: 'Detail',
            entity: 'productSaleNumber',
            loaderType: 'get',
            direction: 'vertical',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 4,
            fields: [
                {
                    property: 'canSaleNumber',
                    label: '当前可卖数',
                },
                {
                    property: 'lockStock',
                    label: '待扣减库存',
                },
                {
                    property: 'totalStock',
                    label: '总库存数',
                },
            ],
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/info/:id',
                            component: 'productInfoDetailView',
                            breadcrumbName: '编辑商品资料',
                        },
                        {
                            path: '/info',
                            component: 'productInfoListView',
                            breadcrumbName: '商品资料中心',
                        },
                        {
                            path: '/goods/:id',
                            component: 'productGoodsView',
                            breadcrumbName: '查看商品经营信息',
                        },
                        {
                            path: '/goods',
                            component: 'productGoodsListView',
                            breadcrumbName: '商品经营管理',
                        },
                        {
                            path: '/brand',
                            component: 'productBrandView',
                            breadcrumbName: '商品品牌管理',
                        },
                        {
                            path: '/presale-stock',
                            component: 'PresaleStockView',
                            breadcrumbName: '预售库存管理',
                        },
                        {
                            path: '/display-location',
                            component: 'displayLocationView',
                            breadcrumbName: '商品参数展示配置',
                        },
                    ],
                },
            ],
        },
    ],
};
